import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAdminOnlyWrapper from 'ui-addon-upgrades/decorators/UIAdminOnlyWrapper';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import { REQUEST_SEAT_UPGRADE } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import { omit } from 'ui-addon-upgrades/utils';
import { getPaidUserManagementUrl } from 'self-service-api/core/utilities/links';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import { getCorrectedUpgradeData } from '../_core/utils/getCorrectedUpgradeData';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import { RequestSeatButtonPropsInterface } from 'ui-addon-upgrades/button/interfaces/requestAssignSeatButtonInterface'; // @ts-expect-error dependency missing types

import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap'; // @ts-expect-error dependency missing types

import { requestSeatUpgrade } from 'ui-addon-upgrades/_core/upgrade/requestSeatUpgrade';
import { getCanViewNewSeats } from '../_core/common/eligibility/getCanViewNewSeats';

const UIRequestSeatButton = props => {
  const {
    upgradeData,
    level,
    usageLimitBannerData,
    showModal,
    onClick = () => {},
    onSuccess = () => {},
    onFailure = () => {}
  } = props;
  const correctedUpgradeData = getCorrectedUpgradeData(upgradeData);
  const propsToPass = omit(props, 'isUpgradePoint', 'upgradeData', 'location', 'subscreen', 'level', 'showModal', 'onClick', 'onSuccess', 'onFailure', 'usageLimitBannerData');
  const [canViewNewSeats, setCanViewNewSeats] = useState();
  useEffect(() => {
    tracker.track('interaction', Object.assign({
      action: 'viewed request seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    getCanViewNewSeats().then(res => {
      setCanViewNewSeats(res);
    }).catch(() => {
      setCanViewNewSeats(false);
    });
  }, [correctedUpgradeData, usageLimitBannerData, level]);

  const onClickHandler = () => {
    tracker.track('interaction', Object.assign({
      action: 'clicked upgrade point'
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));
    tracker.track('interaction', Object.assign({
      action: 'clicked request seat',
      isPrimaryCta: level === 1,
      isSecondaryCta: level === 2
    }, usageLimitBannerData, {}, getUpgradeDataTrackingProperties(correctedUpgradeData, true)));

    if (!showModal) {
      onClick();
      const apiName = UpgradeProductToApiNameMap[correctedUpgradeData.upgradeProduct];
      requestSeatUpgrade({
        apiName
      }).then(() => onSuccess()).catch(() => onFailure());
    }
  }; // UMS Upgrade Modal does the request seat api call itself rather than opening the request seat modal


  if (!showModal) {
    return /*#__PURE__*/_jsx(UIButton, Object.assign({
      "data-reagan-primary-cta": true
    }, propsToPass, {
      onClick: onClickHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      })
    }));
  }

  return /*#__PURE__*/_jsx(UIAdminOnlyWrapper, {
    adminType: TEAM,
    modalType: REQUEST_SEAT_UPGRADE,
    upgradeData: upgradeData,
    onClick: onClickHandler,
    children: /*#__PURE__*/_jsx(UIButton, Object.assign({
      "data-reagan-primary-cta": true
    }, propsToPass, {
      href: getPaidUserManagementUrl(canViewNewSeats),
      target: "_blank",
      onClick: onClickHandler,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "upgrades.requestSeatButton"
      })
    }))
  });
};

UIRequestSeatButton.defaultProps = {
  showModal: true
};
UIRequestSeatButton.propTypes = RequestSeatButtonPropsInterface;
export default UIRequestSeatButton;